import { useMemo } from "react";
import VersatileLink from "@/components/VersatileLink";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TargetLink(_ref) {
  var href = _ref.href,
      blank = _ref.blank,
      className = _ref.className,
      children = _ref.children;
  var target = useMemo(function () {
    return blank ? "_blank" : "_self";
  }, [blank]);

  if (/^(https?:\/\/|\/).+/.test(href)) {
    //httpsがついていた場合新しいタブで開く
    return /*#__PURE__*/_jsx(VersatileLink, {
      href: href,
      children: /*#__PURE__*/_jsx("a", {
        className: className,
        target: target,
        rel: "noreferrer noopener",
        children: children
      })
    });
  } else {
    return /*#__PURE__*/_jsx("a", {
      className: className,
      children: children
    });
  }
}